import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/terms.css';

const Terms = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="terms-page">
      <Header isScrolled={isScrolled} />
      
      {/* Hero Section */}
      <section 
        className="terms-hero"
        style={{
          background: 'linear-gradient(rgba(21, 21, 20, 0.4), rgba(21, 21, 20, 0.4)), url(/assets/Garbary18.jpg)',
          backgroundSize: '170%',
          backgroundPosition: 'top left'
        }}
      >
        <div className="terms-hero-content">
          <h1 className="terms-hero-title">Terms of Service</h1>
          <p className="terms-hero-subtitle">Warunki Świadczenia Usług</p>
        </div>
      </section>

      {/* Terms Content Section */}
      <section className="terms-content">
        <div className="terms-content-wrapper">
          <div className="terms-main-content">
            <div className="terms-section">
              <h2 className="terms-section-title">Acceptance of Terms / Akceptacja Warunków</h2>
              <div className="terms-text">
                <p>By accessing and using Pawilon Krzyżanowskiego's website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our services.</p>
                <p>These terms apply to all users of our website, including visitors, customers purchasing event tickets, private event organizers, and anyone who contacts us through our contact forms.</p>
                <p>We reserve the right to update or modify these terms at any time, and such changes will be effective immediately upon posting on this page. Your continued use of our services after any changes constitutes acceptance of the modified terms.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Korzystając ze strony internetowej i usług Pawilon Krzyżanowskiego, zgadzasz się być związany niniejszymi Warunkami Świadczenia Usług. Jeśli nie zgadzasz się z którąkolwiek częścią tych warunków, proszę nie korzystać z naszych usług.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Event Tickets / Bilety na Wydarzenia</h2>
              <div className="terms-text">
                <p>Event tickets purchased through our website are non-refundable unless the event is cancelled by Pawilon Krzyżanowskiego. In the event of cancellation by us, you will receive a full refund to the original payment method within 14 business days.</p>
                <p>All ticket sales are final. Tickets are valid only for the specific event and date indicated. Each ticket admits one person only.</p>
                <p>You will receive your ticket confirmation and QR code via email after successful payment. It is your responsibility to keep this information secure and present the QR code at the venue entrance.</p>
                <p>We are not responsible for tickets lost, stolen, or damaged after delivery. Tickets may not be resold or transferred without our written consent.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Bilety na wydarzenia zakupione przez naszą stronę internetową nie podlegają zwrotowi, chyba że wydarzenie zostanie odwołane przez Pawilon Krzyżanowskiego. W przypadku anulowania przez nas otrzymasz pełny zwrot kosztów na oryginalną metodę płatności w ciągu 14 dni roboczych.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Venue Rental / Wynajem Lokalu</h2>
              <div className="terms-text">
                <p>The venue is rented as a complete unit, including the main hall, upper room, and terrace. Venue capacity is up to 50 seated guests in the main dining hall.</p>
                <p>Bookings are subject to availability and require a signed contract and deposit to confirm. Rental periods and pricing are determined on a case-by-case basis based on your event requirements.</p>
                <p>Clients are responsible for obtaining any necessary permits, licenses, or insurance for their event. Pawilon Krzyżanowskiego reserves the right to terminate any event that violates local laws or regulations.</p>
                <p>Damage to the venue or its contents during your event will result in charges for repair or replacement. An estimated cost must be provided before the event date.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Lokal wynajmowany jest jako całość, w tym główna sala, górna sala i taras. Pojemność lokalu wynosi do 50 gości przy stołach w głównej sali jadalnej.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Payment Terms / Warunki Płatności</h2>
              <div className="terms-text">
                <p>All payments are processed securely through Stripe. We accept major credit cards including Visa, Mastercard, and American Express.</p>
                <p>Event ticket purchases must be paid in full at the time of purchase. For private event rentals, a non-refundable deposit is required to secure the date, with the remaining balance due according to the terms specified in your rental contract.</p>
                <p>All prices are quoted in Polish Zloty (PLN) or Euro (EUR) as indicated. Prices are subject to change without notice, though confirmed bookings will be honored at the agreed price.</p>
                <p>Failed payments may result in automatic cancellation of bookings. We are not liable for any third-party charges or fees imposed by your bank or credit card company.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Wszystkie płatności są przetwarzane bezpiecznie przez Stripe. Akceptujemy główne karty kredytowe, w tym Visa, Mastercard i American Express.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Liability and Insurance / Odpowiedzialność i Ubezpieczenie</h2>
              <div className="terms-text">
                <p>Pawilon Krzyżanowskiego is not liable for any personal injury, loss, or damage to personal property that occurs during your event, except for injury or damage directly caused by our negligence.</p>
                <p>Clients and their guests enter the venue at their own risk. We recommend that event organizers obtain appropriate insurance coverage for their events, including public liability insurance.</p>
                <p>We are not responsible for any cancellations or modifications to events due to circumstances beyond our control, including but not limited to natural disasters, government regulations, or emergencies.</p>
                <p>Our maximum liability for any claim arising from our services is limited to the amount you paid for the specific service in question.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Pawilon Krzyżanowskiego nie ponosi odpowiedzialności za jakiekolwiek obrażenia osobiste, straty lub uszkodzenie mienia osobistego, które wystąpi podczas Twojego wydarzenia, z wyjątkiem szkód spowodowanych bezpośrednio naszym zaniedbaniem.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Prohibited Activities / Zakazane Działania</h2>
              <div className="terms-text">
                <p>The following activities are strictly prohibited at Pawilon Krzyżanowskiego: smoking indoors, consumption of illegal substances, any form of violence or disorderly conduct, damage to venue property, and exceeding maximum capacity limits.</p>
                <p>Noise levels must be kept reasonable and comply with local regulations. Events that violate noise ordinances may be terminated immediately.</p>
                <p>Open flames, candles, or any potentially hazardous equipment must be approved in advance. Installation of decorations must not damage walls, floors, or fixtures.</p>
                <p>We reserve the right to refuse service to anyone or remove any person from the premises at any time if their behavior is deemed inappropriate or violates these terms.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>W Pawilon Krzyżanowskiego są surowo zabronione następujące działania: palenie w pomieszczeniach zamkniętych, spożywanie nielegalnych substancji, jakakolwiek forma przemocy lub zakłócanie porządku publicznego.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Cancellations and Refunds / Anulowania i Zwroty</h2>
              <div className="terms-text">
                <p>For event tickets: Cancellations made by the customer are non-refundable. If an event is cancelled by Pawilon Krzyżanowskiego, tickets will be fully refunded.</p>
                <p>For private venue rentals: Cancellations must be made in writing. Deposit fees are non-refundable. The balance may be refunded depending on the timing of cancellation and our ability to re-book the date.</p>
                <p>Refunds will be processed to the original payment method within 14 business days of the cancellation decision.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>W przypadku biletów na wydarzenia: Anulowania dokonane przez klienta nie podlegają zwrotowi. Jeśli wydarzenie zostanie odwołane przez Pawilon Krzyżanowskiego, bilety zostaną w pełni zwrócone.</p>
              </div>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Contact Information / Informacje Kontaktowe</h2>
              <div className="terms-text">
                <p>If you have any questions about these Terms of Service or wish to discuss venue rental terms, please contact us at:</p>
                <p><strong>Email:</strong> Garbary96@gmail.com<br />
                <strong>Phone:</strong> 532 883 067<br />
                <strong>Address:</strong> Ul. Garbary 96, 61-757 Poznań, Poland</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Jeśli masz pytania dotyczące niniejszych Warunków Świadczenia Usług lub chcesz omówić warunki wynajmu lokalu, skontaktuj się z nami:</p>
              </div>
            </div>

            <div className="terms-last-updated">
              <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;